module.exports = __webpack_public_path__ + "static/media/ubication.e4f66979.svg";